import React,{ createContext, useState ,useContext,useEffect,useRef,useCallback,useMemo} from "react";
import { getRequest, postRequest, deleteRequest } from "../api/ApiController";
import { Dialog } from 'primereact/dialog';
import { InfinitySpin } from  'react-loader-spinner';
import { DatabaseContext, databaseStoreRef } from "../redux/DatabaseStore";
import AuthContext from "./AuthContext";
import { PassLogoutProvider } from "../auth/passLogoutRef";
import { LocaleContext } from "./LocaleContext";
import skTranslations from '../locales/sk.json';
import enTranslations from '../locales/en.json';
import deTranslations from '../locales/de.json';
import { ConfirmDialog } from "primereact/confirmdialog";
import { getPusherChannel, disconnectPusher } from '../utils/pusherChannel';
import { Toast } from 'primereact/toast';
import { Sidebar } from 'primereact/sidebar';
import { Message } from 'primereact/message';
import { DeleteIcon } from "../pages/svg/svgIcons";
import { CloseMess} from "../pages/svg/svgIcons";
import { useLocation } from 'react-router-dom';
import { resolveCrmTicketDetailPortalView } from '../utils/crmCommunicationPermissions';
import { CRM_COMM_MASK_DETAIL, CRM_COMM_MASK_PORTAL_DETAIL } from '../pages/crm/CrmCommunicationTicketsList';
import namer from 'color-namer';
import MsgReader from '@kenjiuno/msgreader';
import { DateTime } from 'luxon';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import { getDateFormat as getDateFormatUtil, formatDate as formatDateUtil } from '../utils/dateUtils';
import { getUserInitials } from '../utils/userInitials';
import { hydrateTrainingInvitationTemplatesFromAuthPayload } from '../utils/trainingInvitationTemplatesLookup';
import { hydrateChecklistTemplatesFromAuthPayload, resetChecklistTemplatesLookup, syncChecklistTemplatesFromPusher } from '../utils/checklistTemplatesLookup';
import { cleanSorters, normalizeHeaderFiltersForMask, sanitizeTabulatorLayoutAttributes } from '../utils/tabulatorProgressiveLoading';
import { getNotificationLookupTypes, resolveNotificationType } from '../utils/notificationTopics';
import {
  parsePriorityListChosenData,
  parseChannelOnlyChosenPayload,
  NOTIFICATION_CHANNEL_IN_APP,
  openChosenNotifications,
  saveChosenNotifications as saveChosenNotificationsApi,
  savePriorityListChosenNotifications,
  primeNotificationDialogPageType,
} from '../utils/chosenNotifications';
import ChosenNotificationsDialog from './notifications/ChosenNotificationsDialog';
import {
  deepLinkWarnKeyForPage,
  parseErrorRecordShowResponse,
  resolveErrorRecordTab,
  resolveOtkPageFromNotification,
} from '../utils/otkErrorRecordNavigation';
import { processDeepLinksFromSearch } from '../utils/deepLinkHandlers';
const NOTIFICATION_TRANSLATIONS = { sk: skTranslations, en: enTranslations, de: deTranslations };
//import Quill from "quill";

/* File preview dialog body (image toolbar, PDF iframe, .msg, fallback). */
function FilePreviewContent({ url, filename, t }) {
  const [msgData, setMsgData] = useState(null);
  const [msgError, setMsgError] = useState(false);
  const ext = (filename || '').split('.').pop()?.toLowerCase();
  const isImg = ['img', 'png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'svg'].includes(ext || '');

  useEffect(() => {
    if (ext !== 'msg' || !url) return;
    setMsgData(null);
    setMsgError(false);
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(url, { mode: 'cors' });
        if (!res.ok) throw new Error('Fetch failed');
        const buffer = await res.arrayBuffer();
        const msgReader = new MsgReader(buffer);
        const data = msgReader.getFileData();
        if (!cancelled) setMsgData(data);
      } catch (e) {
        if (!cancelled) setMsgError(true);
      }
    })();
    return () => { cancelled = true; };
  }, [url, ext]);

  if (isImg) {
    return (
      <div style={{ flex: 1, minHeight: 0, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
        <TransformWrapper
          initialScale={1}
          minScale={0.5}
          maxScale={4}
          centerOnInit
          limitToBounds
          panning={{ velocityDisabled: true }}
          doubleClick={{ disabled: true }}
          wheel={{ step: 0.1 }}
          style={{ width: '100%', height: '100%', minHeight: 0, overflow: 'hidden' }}
        >
          {({ zoomIn, zoomOut }) => (
              <>
                <div className="flex items-center gap-2 py-1.5 px-2 bg-gray-100 border-b border-gray-200 shrink-0">
                  <button type="button" onClick={() => zoomOut()} className="px-3 py-1.5 bg-zinc-200 hover:bg-zinc-300 rounded font-bold text-lg">−</button>
                  <button type="button" onClick={() => zoomIn()} className="px-3 py-1.5 bg-zinc-200 hover:bg-zinc-300 rounded font-bold text-lg">+</button>
                </div>
                <div style={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
                  <TransformComponent
                    wrapperStyle={{ width: '100%', height: '100%', minHeight: 0, overflow: 'hidden' }}
                    contentStyle={{ width: '100%', height: '100%', minHeight: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                  >
                    <img
                      src={url}
                      alt={filename}
                      style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', touchAction: 'none', userSelect: 'none', display: 'block' }}
                      draggable={false}
                    />
                  </TransformComponent>
                </div>
              </>
            )}
        </TransformWrapper>
      </div>
    );
  }
  if (ext === 'pdf') {
    return (
      <iframe src={url} title={filename} style={{ flex: 1, width: '100%', height: '100%', minHeight: 0, border: 'none' }} />
    );
  }
  if (ext === 'msg') {
    if (msgError) {
      return (
        <div className="flex flex-col items-center justify-center p-4 text-center" style={{ minHeight: '40vh' }}>
          <p className="mb-4 text-sm">{t("Util.FilePreview.MsgLoadError")}</p>
          <a href={url} download={filename} target="_blank" rel="noopener noreferrer" className="px-4 py-2 bg-blue-600 text-white rounded shadow hover:bg-blue-700">{t("Util.FilePreview.Download")}</a>
        </div>
      );
    }
    if (!msgData) {
      return <div className="p-4 text-center">{t("Util.FilePreview.MsgLoading")}</div>;
    }
    return (
      <div className="flex flex-col w-full text-balance overflow-auto p-4" style={{ minHeight: 0 }}>
        <div className="mb-2">
          <label className="font-semibold mr-1">{t("Util.FilePreview.MsgDate")}</label>
          <span>{msgData.messageDeliveryTime ? (() => { try { return DateTime.fromHTTP(msgData.messageDeliveryTime).toFormat('dd.MM.yyyy HH:mm:ss'); } catch { return msgData.messageDeliveryTime; } })() : '–'}</span>
        </div>
        <div className="mb-2">
          <label className="font-semibold mr-1">{t("Util.FilePreview.MsgRecipients")}</label>
          <div>
            {(msgData.recipients || []).map((r, i) => (
              <div key={i}>{r.name}<br /><span className="text-gray-600">{r.smtpAddress}</span></div>
            ))}
          </div>
        </div>
        <div className="mb-2">
          <label className="font-semibold mr-1">{t("Util.FilePreview.MsgSubject")}</label>
          <div>{msgData.subject || '–'}</div>
        </div>
        <div className="mb-2">
          <label className="font-semibold mr-1">{t("Util.FilePreview.MsgBody")}</label>
          <div className="whitespace-pre-wrap">{msgData.body || '–'}</div>
        </div>
      </div>
    );
  }
  const downloadLabel = t("Util.FilePreview.DownloadWithName").replace(/\{\{name\}\}/g, filename || t("Util.FilePreview.DefaultFilename"));
  return (
    <div className="flex flex-col items-center justify-center p-4 text-center" style={{ minHeight: '40vh' }}>
      <p className="mb-4 text-sm">{t("Util.FilePreview.UnsupportedFormat")}</p>
      <a href={url} download={filename} target="_blank" rel="noopener noreferrer" className="px-4 py-2 bg-blue-600 text-white rounded shadow hover:bg-blue-700">{downloadLabel}</a>
    </div>
  );
}

/* Context, which serves to authenticate the user in the system */
const UtilContext = createContext();
export const UtilProvider = {};

export const UtilContextProvider = ({ children }) => {
  
    const { user, logout } = useContext(AuthContext);
    const [state,dispatch] = useContext(DatabaseContext);
    const { t, locale } = useContext(LocaleContext);

    const [dialogText,setDialogText] = useState(""); 
    const [visible,setVisible] = useState(false);
    const [visibleNotifications,setVisibleNotifications] = useState(false);
    const [favoriteVisible,setFavoriteVisible] = useState(false);
    const [favoriteGroupValue,setFavoriteGroupValue] = useState("");
    const [favoriteValue,setFavoriteValue] = useState("");
    const [favoriteName,setFavoriteName] = useState("");
    const [favoritePage,setFavoritePage] = useState("");
    /** Centrálny dialóg „Nastaviť notifikácie“ – stránky volajú openChosenNotificationPreferences(pageType). */
    const chosenNotifPageTypeRef = useRef('');
    const chosenNotifModeRef = useRef('channels');
    const [chosenNotifDialogVisible, setChosenNotifDialogVisible] = useState(false);
    const [chosenNotifDialogMode, setChosenNotifDialogMode] = useState('channels');
    const [chosenNotifChannels, setChosenNotifChannels] = useState([]);
    const [chosenNotifPriorityDepartments, setChosenNotifPriorityDepartments] = useState([]);
    const [chosenNotifDepartmentIds, setChosenNotifDepartmentIds] = useState([]);
    const [chosenNotifPriorityChannelKeys, setChosenNotifPriorityChannelKeys] = useState([]);
    const normalizeNotificationLocale = useCallback((value) => {
        const v = String(value ?? '').trim().toLowerCase();
        if (v === 'gb') return 'en';
        return ['sk', 'en', 'de'].includes(v) ? v : '';
    }, []);
    const [accountPrefsEpoch, setAccountPrefsEpoch] = useState(0);
    useEffect(() => {
        const bump = () => setAccountPrefsEpoch((n) => n + 1);
        window.addEventListener('app-locale-preferences-updated', bump);
        return () => window.removeEventListener('app-locale-preferences-updated', bump);
    }, []);
    /**
     * In-app / Pusher bell: resolve message_key with CURRENT UI locale (navbar).
     * Stored `notification.message` remains fallback for legacy rows without keys.
     * Account preferred_language still drives backend email localization elsewhere.
     */
    const bellContentLocale = useMemo(() => {
        const ui = normalizeNotificationLocale(locale);
        if (ui) return ui;
        const userPreferred = normalizeNotificationLocale(localStorage.getItem('preferred_language_user'));
        if (userPreferred) return userPreferred;
        const companyPreferred = normalizeNotificationLocale(localStorage.getItem('preferred_language_company'));
        if (companyPreferred) return companyPreferred;
        return 'sk';
    }, [normalizeNotificationLocale, accountPrefsEpoch, locale]);
    const translateBellContent = useCallback((key, params = {}) => {
        if (!key) return '';
        const dictionary = NOTIFICATION_TRANSLATIONS[bellContentLocale] || NOTIFICATION_TRANSLATIONS.sk || {};
        let translated = dictionary[key] || NOTIFICATION_TRANSLATIONS.sk?.[key] || key;
        if (typeof translated !== 'string') {
            return String(translated ?? key);
        }
        if (params && typeof params === 'object') {
            Object.entries(params).forEach(([paramKey, paramValue]) => {
                const safeValue = paramValue == null ? '' : String(paramValue);
                translated = translated
                    .replace(new RegExp(`\\{\\{\\s*${paramKey}\\s*\\}\\}`, 'g'), safeValue)
                    .replace(new RegExp(`:${paramKey}\\b`, 'g'), safeValue);
            });
        }
        return translated;
    }, [bellContentLocale]);
    const [filePreviewVisible, setFilePreviewVisible] = useState(false);
    const [filePreviewUrl, setFilePreviewUrl] = useState(null);
    const [filePreviewFilename, setFilePreviewFilename] = useState(null);
    const location = useLocation();

    function openFilePreview({ url, filename }) {
        if (!url) return;
        setFilePreviewUrl(url);
        setFilePreviewFilename(filename || t("Util.FilePreview.DefaultFilename"));
        setFilePreviewVisible(true);
    }

    function closeFilePreview() {
        setFilePreviewVisible(false);
        setFilePreviewUrl(null);
        setFilePreviewFilename(null);
    }

    const parseNotificationPayload = useCallback((notification) => {
        try {
            if (!notification?.data) return {};
            if (typeof notification.data === 'object') {
                if (notification.data?.data && typeof notification.data.data === 'string') {
                    const nested = JSON.parse(notification.data.data);
                    return { ...notification.data, ...nested };
                }
                return notification.data;
            }
            if (typeof notification.data === 'string') {
                return JSON.parse(notification.data);
            }
            return {};
        } catch (_e) {
            return {};
        }
    }, []);

    const resolveNotificationMessage = useCallback((notification) => {
        const payload = parseNotificationPayload(notification);
        const messageKey = payload?.message_key;
        const messageParams = payload?.message_params;
        if (typeof messageKey === 'string' && messageKey.trim() !== '') {
            const translated = translateBellContent(messageKey, messageParams || {});
            if (translated && translated !== messageKey) {
                return translated;
            }
        }
        return notification?.message || '';
    }, [parseNotificationPayload, translateBellContent]);

    const resolveNotificationModule = useCallback((notification) => {
        const payload = parseNotificationPayload(notification);
        const moduleKey = payload?.module_key;
        const moduleParams = payload?.module_params;
        if (typeof moduleKey === 'string' && moduleKey.trim() !== '') {
            const translated = translateBellContent(moduleKey, moduleParams || {});
            if (translated && translated !== moduleKey) {
                return translated;
            }
        }
        return payload?.module || '';
    }, [parseNotificationPayload, translateBellContent]);

    const toast = useRef(null);
    const [toastPosition,setToastPosition] = useState("top-right");
    const prevUserRef = useRef(user);

    /* Pri každom odhlásení (tlačidlo aj 401) vynulovať Redux, aby po prihlásení iného používateľa neostali staré dáta */
    useEffect(() => {
        if (prevUserRef.current !== null && user === null) {
            dispatch({ type: 'set_initial_state' });
            dataLoadedRef.current = false;
            processedDeepLinkRef.current = '';
        }
        prevUserRef.current = user;
    }, [user, dispatch]);

    UtilProvider.setVisible = setVisible;
    UtilProvider.setDialogText = setDialogText;
    UtilProvider.toast = toast;
    UtilProvider.setToastPosition = setToastPosition;

    const dataLoadedRef = useRef(false);
    const processedDeepLinkRef = useRef('');

    const showOpenTabWarn = useCallback((detail) => {
        toast?.current?.show({
            severity: 'warn',
            summary: t('Util.Toast.WarningSummary'),
            detail: detail || t('Util.DeepLink.RecordFailedDefault'),
            life: 5000,
        });
    }, [t, toast]);

    const withDetailLoader = useCallback((fn) => {
        const hadVisible = visible;
        const prevText = dialogText;
        if (hadVisible) {
            setDialogText(t('Util.Loading.Detail'));
        } else {
            setDialogText(t('Util.Loading.Detail'));
            setVisible(true);
        }
        return Promise.resolve()
            .then(fn)
            .finally(() => {
                if (hadVisible) setDialogText(prevText || t('Util.Loading.Data'));
                else setVisible(false);
            });
    }, [dialogText, t, visible]);

    const openErrorRecordFromApi = useCallback((recordId, preferredPage = null) => {
        const id = parseInt(String(recordId ?? ''), 10);
        if (!Number.isFinite(id) || id <= 0) return Promise.resolve();
        const pageHint = String(preferredPage ?? '').trim() || null;
        return withDetailLoader(() =>
            getRequest(`/api/error_records/${id}`).then((res) => {
                const errorRecord = parseErrorRecordShowResponse(res);
                if (!errorRecord) {
                    showOpenTabWarn(t(deepLinkWarnKeyForPage(pageHint)));
                    return;
                }
                const tab = resolveErrorRecordTab(errorRecord, pageHint);
                if (!tab) {
                    showOpenTabWarn(t('Util.DeepLink.RecordFailedDefault'));
                    return;
                }
                dispatch({
                    type: 'create_new_tab',
                    name: t(tab.titleKey), translationKey: tab.titleKey, legacyLabel: t(tab.titleKey),
                    page: tab.page,
                    props: { error_record: errorRecord, er_type: 'edit' },
                    mask: tab.mask,
                });
            }).catch(() => {
                showOpenTabWarn(t(deepLinkWarnKeyForPage(pageHint)));
            }),
        );
    }, [dispatch, showOpenTabWarn, t, withDetailLoader]);

    const deepLinkCtx = useMemo(() => ({
        user,
        dispatch,
        t,
        getRequest,
        withDetailLoader,
        showOpenTabWarn,
        openErrorRecordFromApi,
    }), [dispatch, openErrorRecordFromApi, showOpenTabWarn, t, user, withDetailLoader]);

    const runDeepLinksFromSearch = useCallback((search, { force = false } = {}) => {
        if (!search || !user) return;
        if (!force && processedDeepLinkRef.current === search) return;
        processedDeepLinkRef.current = search;
        processDeepLinksFromSearch(search, deepLinkCtx);
    }, [deepLinkCtx, user]);

    async function fetchDatafromDB(){
        const authUser = user;
        const sessionUserId = authUser?.id != null ? Number(authUser.id) : null;
        const reduxUserId = databaseStoreRef.current?.state?.user?.id != null
            ? Number(databaseStoreRef.current.state.user.id)
            : null;
        /* Pri zmene účtu nesmie zostať starý state.user (useEffect má vypnuté exhaustive deps).
           Po odhlásení môže ešte dobehnúť starý startRequest — ten nesmie prepísať nový účet. */
        if (authUser && reduxUserId !== sessionUserId) {
            setDialogText(t("Util.Loading.Data"));
            setVisible(true);
            dispatch({ type: 'set_initial_state' });
            dispatch({ type: 'login_user', newUser: authUser });
            dispatch({ type: 'load_last_used' });
        }
        if (authUser) {
            await getRequest("/api/auth/startRequest").then((response) => {
                if (Number(PassLogoutProvider.user?.id) !== sessionUserId) {
                    return;
                }
                if (!response?.data?.employees || (response.status && response.status >= 400)) {
                    if (Number(PassLogoutProvider.user?.id) !== sessionUserId) return;
                    setToastPosition("top-center");
                    setVisible(false);
                    toast?.current?.show({ severity: 'error', summary: t("Common.Error"), detail: t("Util.StartRequest.LoadFailedDetail"), sticky: true });
                    logout();
                    return;
                }
                dispatch({type:'load_employees',newEmployees:response.data.employees});
                dispatch({type:'load_departments',newDepartments:response.data.departments});
                dispatch({type:'load_companies',newCompanies:response.data.companies});
                // company_certificates – už sa neukladajú do state (progressive loading cez paged API v listoch/detaloch)
                if (response.data.company_contacts?.length) dispatch({type:'load_company_contacts',newCompanyContacts:response.data.company_contacts});
                dispatch({type:'load_fast_view',newFastView:response.data.fast_view});
                dispatch({type:'load_user_mask_filters',newUserMaskFilters:response.data.user_mask_filters});
                dispatch({type:'load_standard_mask_filters',newStandardMaskFilters:response.data.standard_mask_filters || []});
                dispatch({type:'load_favorites',newFavorites:response.data.favorites});
                dispatch({type:'load_chosen_notifications',newChosenNotifications:response.data.chosen_notifications});
                dispatch({type:'load_notifications',newNotifications:response.data.notifications});
                getRequest('/api/support_tickets/count').then((countRes) => {
                  if (Number(PassLogoutProvider.user?.id) !== sessionUserId) return;
                  dispatch({ type: 'load_support_tickets_open_count', count: countRes?.data?.count ?? countRes?.count ?? 0 });
                }).catch(() => {
                  if (Number(PassLogoutProvider.user?.id) !== sessionUserId) return;
                  dispatch({ type: 'load_support_tickets_open_count', count: 0 });
                });
                if(response.data.service_levels) dispatch({type:'load_service_levels',newServiceLevels:response.data.service_levels});
                if(response.data.service_states) dispatch({type:'load_service_states',newServiceStates:response.data.service_states});
                if(response.data.task_templates) dispatch({type:'load_task_templates',newTaskTemplates:response.data.task_templates});
                if(response.data.service_user_settings) dispatch({type:'load_service_user_settings',newServiceUserSettings:response.data.service_user_settings});
                if(response.data.crm_levels) dispatch({type:'load_crm_levels',newCrmLevels:response.data.crm_levels});
                if(response.data.crm_level_user_settings) dispatch({type:'load_crm_level_user_settings',newCrmLevelUserSettings:response.data.crm_level_user_settings});
                if(response.data.crm_states) dispatch({type:'load_crm_states',newCrmStates:response.data.crm_states});
                if(response.data.crm_steps) dispatch({type:'load_crm_steps',newCrmSteps:response.data.crm_steps});
                if(response.data.crm_traders) dispatch({type:'load_crm_traders',newCrmTraders:response.data.crm_traders});
                dispatch({type:'load_users',newUsers:response.data.users});
                if(user.permissions?.includes('access users')){
                    dispatch({type:'load_roles',newRoles:response.data.roles});
                }
                hydrateChecklistTemplatesFromAuthPayload(dispatch, response.data);
                // checklist_records, checklist_state_records, checklist_all_records – progressive loading cez paged API
                if(user.permissions?.includes('access priorities')){
                    dispatch({type:'load_priority_departments',newPriorityDepartments:response.data.priority_departments});
                    dispatch({type:'load_priorities',newPriorities:response.data.priorities});
                }
                // OTK – error_types, groups, preventions, root_causes, measure_complexities pre formuláre (section1/2/3 alebo setup)
                if(user.permissions?.includes('access otk-section1') || user.permissions?.includes('access otk-section2') || user.permissions?.includes('access otk-section3') || user.permissions?.includes('access otk-setup')){
                    if(response.data.error_types) dispatch({type:'load_error_types',newErrorTypes:response.data.error_types});
                    if(response.data.root_causes) dispatch({type:'load_root_causes',newRootCauses:response.data.root_causes});
                    if(response.data.groups) dispatch({type:'load_groups',newGroups:response.data.groups});
                    if(response.data.preventions) dispatch({type:'load_preventions',newPreventions:response.data.preventions});
                    if(response.data.measure_complexities) dispatch({type:'load_measure_complexities',newMeasureComplexities: response.data.measure_complexities});
                    if(response.data.protocol_types) dispatch({type:'load_protocol_types',newProtocolTypes:response.data.protocol_types});
                }
                // OTK – error_records, offenders (protokoly self_control/ndt/annealing sa načítavajú v detaile cez GET /api/error_records/protocols/{id})
                if(user.permissions?.includes('access otk-section1') || user.permissions?.includes('access otk-section2') || user.permissions?.includes('access otk-section3')){
                    if(response.data.offenders) dispatch({type:'load_offenders',newOffenders:response.data.offenders});
                    if(response.data.error_records) dispatch({type:'load_error_records',newErrorRecords:response.data.error_records});
                }
                if((user.permissions?.includes('access settings') || user.permissions?.includes('access otk-statistics')) && response.data.company_statistics){
                    dispatch({type:'load_company_statistics',newCompanyStatistics: response.data.company_statistics});
                }
                // Lakovňa – hlavný modul (podmienky, intervaly, počasie). painting_conditions sa načítavajú cez paged API v PaintingConditionList
                if(user.permissions?.includes('access painting')){
                    if(response.data.painting_intervals) dispatch({type:'load_painting_intervals',newPaintingIntervals:response.data.painting_intervals});
                    if(response.data.weather) dispatch({type:'load_weather',newWeather:response.data.weather});
                }
                // Lakovňa – nastavenia (časové podmienky, používatelia) + intervaly/počasie ak má len setup
                if(user.permissions?.includes('access painting-setup')){
                    if(response.data.painting_intervals) dispatch({type:'load_painting_intervals',newPaintingIntervals:response.data.painting_intervals});
                    if(response.data.weather) dispatch({type:'load_weather',newWeather:response.data.weather});
                    if(response.data.painting_time_conditions) dispatch({type:'load_painting_time_conditions',newPaintingTimeConditions:response.data.painting_time_conditions});
                    if(response.data.painting_employee_conditions) dispatch({type:'load_painting_employee_conditions',newPaintingEmployeeConditions:response.data.painting_employee_conditions});
                }
                if(user.permissions?.includes('access otk-setup') || user.permissions?.includes('access painting-setup') || user.permissions?.includes('access calibration-setup') || user.permissions?.includes('access checklists-setup') || user.permissions?.includes('access training-setup') || user.permissions?.includes('access maintenance-setup')){
                    if(response.data.summary_emails) dispatch({type:'load_summary_emails',newSummaryEmails:response.data.summary_emails});
                    if(response.data.checklist_holidays) dispatch({type:'load_checklist_holidays',newChecklistHolidays:response.data.checklist_holidays});
                }
                if(response.data.module_settings) dispatch({type:'load_module_settings',newModuleSettings:response.data.module_settings});
                if (Object.prototype.hasOwnProperty.call(response.data || {}, 'preferred_language')) {
                    const userPreferredLanguage = response.data.preferred_language ? String(response.data.preferred_language).toLowerCase() : '';
                    if (userPreferredLanguage) localStorage.setItem('preferred_language_user', userPreferredLanguage);
                    else localStorage.removeItem('preferred_language_user');
                }
                if (Object.prototype.hasOwnProperty.call(response.data || {}, 'company_preferred_language')) {
                    const companyPreferredLanguage = response.data.company_preferred_language ? String(response.data.company_preferred_language).toLowerCase() : '';
                    if (companyPreferredLanguage) localStorage.setItem('preferred_language_company', companyPreferredLanguage);
                    else localStorage.removeItem('preferred_language_company');
                }
                window.dispatchEvent(new Event('app-locale-preferences-updated'));
                if (Object.prototype.hasOwnProperty.call(response.data || {}, 'company_settings_print')) {
                    dispatch({ type: 'load_company_settings_print', newCompanySettingsPrint: response.data.company_settings_print });
                }
                if (Object.prototype.hasOwnProperty.call(response.data || {}, 'branding')) {
                    dispatch({ type: 'load_branding', newBranding: response.data.branding });
                }
                if(user.permissions?.includes('access calibration')){
                    if(response.data.gauges) dispatch({type:'load_gauges',newGauges:response.data.gauges});
                    if(response.data.gauge_calibrations) dispatch({type:'load_gauge_calibrations',newGaugeCalibrations:response.data.gauge_calibrations});
                }
                if(user.permissions?.includes('access training')){
                    dispatch({type:'load_lecturers',newLecturers:response.data.lecturers});
                }
                hydrateTrainingInvitationTemplatesFromAuthPayload(dispatch, response.data);
                if((user.permissions?.includes('access training-setup') || user.permissions?.includes('access training-company')) && !response.data.training_types){
                    if(response.data.lecturers) dispatch({type:'load_lecturers',newLecturers:response.data.lecturers});
                }
                dispatch({type:'load_machines',newMachines:response.data?.machines});
                dispatch({type:'load_machine_types',newMachineTypes:response.data?.machine_types});
                if(user.permissions?.includes('access maintenance')){
                    // maintenance_types, maintenance_templates, machine_cards, maintenance_scheduled_records: načítavajú sa progresívne (paged) alebo cez GET pri mounte
                }
                if (location?.search) {
                    runDeepLinksFromSearch(location.search);
                }
                dataLoadedRef.current = true;
            }).catch((reason) => {
                console.log(reason);
                if (Number(PassLogoutProvider.user?.id) !== sessionUserId) return;
                setToastPosition("top-center");
                setVisible(false);
                toast?.current?.show({ severity: 'error', summary: t("Common.Error"), detail: t("Util.StartRequest.LoadFailedDetail"), sticky: true });
                logout();
            })
        }
    }

    useEffect(() => {
        if (user !== null) {
            const effectUserId = Number(user?.id);
            setDialogText(t("Util.Loading.Data"));
            setVisible(true);
            fetchDatafromDB().then(() => {                
                if (Number(PassLogoutProvider.user?.id) !== effectUserId) return;
                setVisible(false);
                setToastPosition("top-right");
            }).catch(() => {
                if (Number(PassLogoutProvider.user?.id) !== effectUserId) return;
                setVisible(false);
                setToastPosition("top-center");
                toast?.current?.show({ severity: 'error', summary: t("Common.Error"), detail: t("Util.StartRequest.LoadFailedDetail"), sticky: true });
                logout();
            });
        } else {
            setVisible(false);
        }
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [user]);

      useEffect(() => {
        if (!user || !location.search || !dataLoadedRef.current) return;
        runDeepLinksFromSearch(location.search);
      }, [location.search, runDeepLinksFromSearch, user]);

      useEffect(() => {
        if (user !== null && state.chosen_notifications !== null) {
            const channel = getPusherChannel();
            channel.bind('isg-event', function(notification) {
                const parsedPayload = JSON.parse(notification.data.data);
                let page = parsedPayload?.page;
                const notificationRecipientId = Number(notification?.data?.user_id ?? parsedPayload?.user_id ?? 0);
                const isCurrentRecipient = Number.isFinite(notificationRecipientId) && notificationRecipientId > 0 && notificationRecipientId === Number(user?.id);
                const lookupTypes = getNotificationLookupTypes(page);
                let result = this.chosen_notifications.filter((chosen) => lookupTypes.includes(chosen.type));
                /* CRM „Moji partneri“: notifikácia má user_id príjemcu; starý obal if (notification.user_id !== user.id) ju pri číselnej zhode vynechá.
                   Doručíme len skutočnému príjemcovi a len ak má zapnutý in-app pre topic crm.sales_evaluation. */
                if (page === 'CustomerMyCustomersDetail' && isCurrentRecipient && result.length > 0) {
                    try {
                        const chosen_detail = JSON.parse(result[0].data);
                        const channels = parseChannelOnlyChosenPayload(chosen_detail);
                        if (channels.includes(NOTIFICATION_CHANNEL_IN_APP)) {
                            dispatch({ type: 'add_notification', value: notification });
                        }
                    } catch (_e) { /* ignore */ }
                }
                if(notification?.user_id!==user.id){
                    //console.log(notification,this.chosen_notifications);
                    if(page==="SupportTicketList" || page==="SupportTicketDetail"){
                        if(parsedPayload?.mentions?.includes(user.id)){
                            dispatch({type:'add_notification',value:notification});
                        }
                    }
                    else if(page==="ServiceUserSettingList" && (user?.permissions?.includes('access service_task-setup') || user?.permissions?.includes('access maintenance'))){
                        getRequest("/api/service_levels").then((response) => {
                                dispatch({type:'load_service_levels',newServiceLevels:response.data});
                        });
                        getRequest("/api/service_user_settings").then((response) => {
                                dispatch({type:'load_service_user_settings',newServiceUserSettings:response.data});
                        });
                    }
                    else if(result.length>0){
                        let chosen_detail = JSON.parse(result[0].data);
                        const isPriorityBoard = page === 'PriorityList' || resolveNotificationType(page) === 'priorities.list';
                        if(isPriorityBoard){
                            const { departments, channels } = parsePriorityListChosenData(JSON.stringify(chosen_detail));
                            const prioPayload = JSON.parse(notification.data.data);
                            const deptId = prioPayload?.department_id;
                            const offId = prioPayload?.offender_department_id;
                            const selected = new Set(departments.map((x) => Number(x)));
                            const hitDept = deptId != null && !Number.isNaN(Number(deptId)) && selected.has(Number(deptId));
                            const hitOff = offId != null && !Number.isNaN(Number(offId)) && selected.has(Number(offId));
                            const wantsInApp = channels.includes(NOTIFICATION_CHANNEL_IN_APP);
                            if(hitDept || hitOff){
                                if(wantsInApp){
                                    dispatch({type:'add_notification',value:notification});
                                }
                                getRequest("/api/priorities").then((response) => {
                                    dispatch({type:'load_priorities',newPriorities:response.data});
                                });
                            }
                        }
                        else{
                            const notifState = parsedPayload?.state;
                            const channels = parseChannelOnlyChosenPayload(chosen_detail);
                            const wantsInApp = channels.includes(NOTIFICATION_CHANNEL_IN_APP);
                            const legacyArray = Array.isArray(chosen_detail);
                            const legacyStateHit =
                              legacyArray &&
                              notifState != null &&
                              chosen_detail.some((x) => String(x) === String(notifState));
                            const canShowInApp = (page === 'ServiceTaskDetail' || page === 'CrmCommunicationTicketDetail')
                                ? isCurrentRecipient
                                : true;
                            if (page !== 'CustomerMyCustomersDetail' && canShowInApp && (wantsInApp || legacyStateHit)) {
                                dispatch({type:'add_notification',value:notification});
                            }
                        }
                    }
                }
                if(page==="ChecklistRecordMyList"){
                    if(user?.permissions?.includes('access checklists') || user?.permissions?.includes('access checklists-setup')){
                        getRequest("/api/checklist_templates").then((response) => {
                            dispatch({type:'load_checklist_templates',newChecklistTemplates:response.data});
                        });
                    }
                    // Zoznamy používajú progressive loading – pri otvorení stránky sa načítajú cez paged API
                }
                if(page==="ChecklistTemplateList"){
                    syncChecklistTemplatesFromPusher({
                        dispatch,
                        state: databaseStoreRef.current?.state || state,
                        user,
                    });
                }
            },{chosen_notifications: state.chosen_notifications});
            return () => { channel.unbind('isg-event'); };
        }
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [user,state.chosen_notifications]);

      /* Disconnect Pusher only on logout – shared channel used by lists too */
      useEffect(() => {
        if (user === null) {
          disconnectPusher();
          resetChecklistTemplatesLookup();
        }
      }, [user]);

    function openFavoriteDialog(favoriteName,favoritePage){
        setFavoriteName(favoriteName);
        setFavoritePage(favoritePage);
        setFavoriteVisible(true);
    }

    function confirmFavoriteDialog(){
        if(favoriteGroupValue===""){
            alert(t("Util.Favorite.Alert.SelectGroup"));
            return;
        }
        else if(favoriteGroupValue==="nova"){
            if(favoriteValue===""){
                alert(t("Util.Favorite.Alert.EnterNewGroupName"));
                return;
            }
            else{
                //VYTVORIT SKUPINU AJ FAVORITA
                setFavoriteVisible(false);
                setVisible(true);
                let formData = new FormData();
                formData.append("name", favoriteValue);
                postRequest(`/api/favorite_groups`, formData,true)
                .then((response) => {
                let formData2 = new FormData();
                formData2.append("name", favoriteName);
                formData2.append("page", favoritePage);
                formData2.append("favorite_group_id", response.data.id);
                postRequest(`/api/favorites`, formData2,true)
                .then((response) => {
                    getRequest("/api/my_favorite_groups").then((response) => {
                        dispatch({type:'load_favorites',newFavorites:response.data});
                        setVisible(false);
                    });
                }).catch((reason) => {
                    setVisible(false);
                    if(!navigator.online){
                        alert(t("ServiceTask.OfflineQueuedAlert"));
                    }
                    else{
                        alert(t("ServiceTask.ActionFailed"));
                    }
                })
                }).catch((reason) => {
                    setVisible(false);
                    if(!navigator.online){
                        alert(t("ServiceTask.OfflineQueuedAlert"));
                    }
                    else{
                        alert(t("ServiceTask.ActionFailed"));
                    }
                })
                setFavoriteName("");
                setFavoritePage("");
                setFavoriteGroupValue("");
                setFavoriteValue("");
            }
        }
        else{
            //VYTVORIT FAVORITA a pridat do skupiny
            setFavoriteVisible(false);
            setVisible(true);
            let formData2 = new FormData();
            formData2.append("name", favoriteName);
            formData2.append("page", favoritePage);
            formData2.append("favorite_group_id", favoriteGroupValue);
            postRequest(`/api/favorites`, formData2,true)
            .then((response) => {
                getRequest("/api/my_favorite_groups").then((response) => {
                    dispatch({type:'load_favorites',newFavorites:response.data});
                    setVisible(false);
                });
            }).catch((reason) => {
                setVisible(false);
                if(!navigator.online){
                    alert(t("ServiceTask.OfflineQueuedAlert"));
                }
                else{
                    alert(t("ServiceTask.ActionFailed"));
                }
            })
            setFavoriteName("");
            setFavoritePage("");
            setFavoriteGroupValue("");
            setFavoriteValue("");
        }
    }

    function setFastView(page_name,columns=null,attributes=null){
        setDialogText(t("Util.Loading.Configuring"));
        setVisible(true);
        let formData = new FormData();
        formData.append("page", page_name);
        formData.append("columns", JSON.stringify(columns));
        formData.append("attributes", JSON.stringify(attributes));
        postRequest(`/api/fast_views`, formData,true)
        .then((response) => {
            if(response?.status === 201 && response?.data != null){
              dispatch({type:'load_fast_view',newFastView:response.data});
              toast?.current?.show({ severity: 'info', summary: t('ServiceTask.Confirmed'), life: 3000, detail: t('Util.FastView.Saved') });
            }
        }).catch((reason) => {
          console.log(reason);
          alert(t("ServiceTask.ActionFailed"));
        }).finally(() => {
          setVisible(false);
        });
    }

    function setUserMaskFilter(page_name, type, columns=null, filters=null, attributes=null, sorters=null, onSuccess=null) {
        setDialogText(t("Util.Loading.Configuring"));
        setVisible(true);
        const formData = new FormData();
        formData.append("page", page_name);
        formData.append("type", type);
        const maskTypeLower = String(type || "").toLowerCase();
        let filtersForSend = filters;
        let sortersForSend = sorters;
        if (filters !== null && filters !== undefined && (maskTypeLower === "set_filters" || maskTypeLower === "all")) {
            // Niektoré stránky (napr. ServiceTaskList/AllList) ukladajú filtre ako objekt.
            // Normalizáciu aplikuj iba na Tabulator array tvar, object nechaj bez zmeny.
            filtersForSend = Array.isArray(filters)
                ? normalizeHeaderFiltersForMask(filters)
                : filters;
        }
        if (sorters !== null && sorters !== undefined && (maskTypeLower === "set_sorters" || maskTypeLower === "all")) {
            sortersForSend = cleanSorters(Array.isArray(sorters) ? sorters : []);
        }
        // posielaj iba ak máš hodnotu (nie null/undefined)
        if (columns !== null && columns !== undefined)formData.append("columns", JSON.stringify(columns));
        if (filters !== null && filters !== undefined)formData.append("filters", JSON.stringify(filtersForSend));
        if (attributes !== null && attributes !== undefined) {
            const sanitizedAttributes = sanitizeTabulatorLayoutAttributes(attributes);
            formData.append("attributes", JSON.stringify(sanitizedAttributes));
        }
        const my_sorters = Array.isArray(sortersForSend) && sortersForSend.length
            ? sortersForSend.map((s) => ({ column: s.field ?? s.column, dir: s.dir }))
            : [];
        // toto posielaj len keď to má význam
        if (sorters !== null && sorters !== undefined) {
            formData.append("sorters", JSON.stringify(my_sorters));
        }
        postRequest(`/api/user_mask_filters`, formData, true)
        .then((response) => {
            if (response.status === 201) {
                dispatch({ type: "load_user_mask_filters", newUserMaskFilters: response.data });
                toast?.current?.show({ severity: "info", summary: t("ServiceTask.Confirmed"), life: 3000, detail: t("Util.Mask.Saved") });
                if (typeof onSuccess === "function") {
                    try { onSuccess(response.data); } catch (e) { console.error(e); }
                }
            }
            setVisible(false);
            })
        .catch((reason) => {
            console.log(reason);
            setVisible(false);
            alert(t("ServiceTask.ActionFailed"));
        });
    }

    /** Uloží štandardnú masku (len columns + attributes). Zobrazí loading dialóg. */
    function setStandardMaskFilter(page, columns, attributes) {
        setDialogText(t("Util.StandardMask.SavingDialog"));
        setVisible(true);
        const formData = new FormData();
        formData.append("page", page);
        if (columns != null) formData.append("columns", JSON.stringify(columns));
        if (attributes != null) {
            const sanitizedAttributes = sanitizeTabulatorLayoutAttributes(attributes);
            formData.append("attributes", JSON.stringify(sanitizedAttributes));
        }
        postRequest(`/api/standard_mask_filters`, formData, true)
            .then((response) => {
                const list = response?.data ?? response;
                if (Array.isArray(list)) {
                    dispatch({ type: "load_standard_mask_filters", newStandardMaskFilters: list });
                }
                toast?.current?.show({
                    severity: "info",
                    summary: t("Util.StandardMask.ToastTitle"),
                    life: 4000,
                    detail: t("Util.StandardMask.SaveSuccessDetail"),
                });
            })
            .catch((reason) => {
                console.log(reason);
                toast?.current?.show({ severity: "error", summary: t("Common.Error"), life: 3000, detail: t("Util.StandardMask.SaveErrorDetail") });
            })
            .finally(() => setVisible(false));
    }

    /** Zmaže štandardnú masku podľa id; response.data je nový zoznam. Zobrazí loading dialóg. */
    function deleteStandardMaskFilter(id) {
        setDialogText(t("Util.StandardMask.ResettingDialog"));
        setVisible(true);
        deleteRequest(`/api/standard_mask_filters/${id}`)
            .then((response) => {
                const list = response?.data ?? response;
                if (Array.isArray(list)) {
                    dispatch({ type: "load_standard_mask_filters", newStandardMaskFilters: list });
                }
                toast?.current?.show({ severity: "info", summary: t("ServiceTask.Confirmed"), life: 3000, detail: t("Util.StandardMask.DeleteSuccessDetail") });
            })
            .catch((reason) => {
                console.log(reason);
                toast?.current?.show({ severity: "error", summary: t("Common.Error"), life: 3000, detail: t("Util.StandardMask.DeleteErrorDetail") });
            })
            .finally(() => setVisible(false));
    }

    const hasAll = (...perms) => perms?.every(p => user?.permissions?.includes(p));

    function formatID(prefix, minDigits, id) {
        const paddedId = id?.toString()?.padStart(minDigits, '0');
        return `${prefix}${paddedId}`;
    }

    function getDateFormat() {
        return getDateFormatUtil(state?.module_settings);
    }

    function formatDate(value, withTime = false) {
        return formatDateUtil(value, getDateFormat(), withTime);
    }

    function getUserColor(username) {
        // Step 1: Convert username to a number
        if(!username)return `#fff`;
        let sumAscii = 0;
        for (let i = 0; i < username.length; i++) {
            sumAscii += username.charCodeAt(i);
        }
        
        // Step 2: Generate RGB values based on the sum
        let r = (sumAscii * 37) % 256;
        let g = (sumAscii * 59) % 256;
        let b = (sumAscii * 83) % 256;
        
        // Step 3: Convert RGB values to hex format
        let color = `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
        return color;
    }

    const COLOR_BASE_KEYS = ['red', 'blue', 'green', 'yellow', 'orange', 'purple', 'pink', 'black', 'white', 'gray', 'brown', 'cyan', 'magenta', 'lime', 'navy', 'teal', 'olive', 'maroon', 'aqua', 'silver', 'gold'];

    /** Localized basic colour name from hex (namer → Util.Color.*). */
    const getSlovakColorName = (hex) => {
        try {
            const result = namer(hex);
            const englishName = result.basic[0].name.toLowerCase();
            const baseColor = COLOR_BASE_KEYS.find((key) => englishName.includes(key));
            if (baseColor) return t(`Util.Color.${baseColor}`);
            return t('Util.Color.UnknownNamed').replace(/\{\{name\}\}/g, englishName);
        } catch {
            return t('Util.Color.Unknown');
        }
    };

    // getUserInitials: pure helper from utils/userInitials (display-name string only).

    const openNotificationTarget = useCallback((notification) => {
        const payload = parseNotificationPayload(notification);
        const page = payload?.page;
        if (!page) {
            return false;
        }
        if (page === 'PriorityList' || page === 'priorities.list') {
            const priorityId = payload?.priority_id ?? payload?.id;
            const problemId = payload?.problem_id ?? null;
            if (priorityId != null && Number.isFinite(Number(priorityId)) && Number(priorityId) > 0) {
                const params = new URLSearchParams({ tab: 'PriorityList', priority_id: String(priorityId) });
                if (problemId != null) params.set('problem_id', String(problemId));
                runDeepLinksFromSearch(`?${params.toString()}`, { force: true });
                return true;
            }
            return false;
        }
        const entityId = payload?.id != null ? Number(payload.id) : null;
        if (entityId == null || !Number.isFinite(entityId) || entityId <= 0) {
            return false;
        }
        if (page === 'CrmCommunicationTicketDetail') {
            const portalView = resolveCrmTicketDetailPortalView(user);
            dispatch({
                type: 'create_new_tab',
                name: t('CrmCommunication.Tab.TicketDetail'), translationKey: 'CrmCommunication.Tab.TicketDetail', legacyLabel: t('CrmCommunication.Tab.TicketDetail'),
                page: 'CrmCommunicationTicketDetail',
                props: { ticketId: entityId, portalView },
                mask: portalView ? CRM_COMM_MASK_PORTAL_DETAIL : CRM_COMM_MASK_DETAIL,
            });
            return true;
        }
        if (page === 'ServiceTaskDetail') {
            dispatch({
                type: 'create_new_tab',
                name: t('Util.Tab.ServiceTaskDetail'), translationKey: 'Util.Tab.ServiceTaskDetail', legacyLabel: t('Util.Tab.ServiceTaskDetail'),
                page: 'ServiceTaskDetail',
                props: { taskId: entityId },
                mask: 'intr003',
            });
            return true;
        }
        if (page === 'SupportTicketDetail' || page === 'SupportTicketList') {
            dispatch({
                type: 'create_new_tab',
                name: t('Util.Tab.TicketDetail'), translationKey: 'Util.Tab.TicketDetail', legacyLabel: t('Util.Tab.TicketDetail'),
                page: 'SupportTicketDetail',
                props: { ticketId: entityId },
                mask: 'help002',
            });
            return true;
        }
        if (page === 'ChecklistStateDetail') {
            const isManager = user?.permissions?.includes('edit checklists');
            dispatch({
                type: 'create_new_tab',
                name: t('Util.Tab.ChecklistRecord'), translationKey: 'Util.Tab.ChecklistRecord', legacyLabel: t('Util.Tab.ChecklistRecord'),
                page: isManager ? 'ChecklistStateDetail' : 'ChecklistRecordMyDetail',
                props: { recordId: entityId },
                mask: 'chck006',
            });
            return true;
        }
        if (page === 'CustomerMyCustomersDetail') {
            dispatch({
                type: 'create_new_tab',
                name: t('CustomerMyCustomersDetail.Title'), translationKey: 'CustomerMyCustomersDetail.Title', legacyLabel: t('CustomerMyCustomersDetail.Title'),
                page: 'CustomerMyCustomersDetail',
                props: { customerId: entityId, type: 'edit' },
                mask: 'cust014',
            });
            return true;
        }
        if (page === 'CustomerAllPartnersDetail') {
            dispatch({
                type: 'create_new_tab',
                name: t('CustomerAllPartnersDetail.Title'), translationKey: 'CustomerAllPartnersDetail.Title', legacyLabel: t('CustomerAllPartnersDetail.Title'),
                page: 'CustomerAllPartnersDetail',
                props: { customerId: entityId, type: 'edit' },
                mask: 'cust017',
            });
            return true;
        }
        if (page === 'CustomerMyBusinessByCustomerDetail') {
            dispatch({
                type: 'create_new_tab',
                name: t('CustomerMyBusinessByCustomerDetail.Title'), translationKey: 'CustomerMyBusinessByCustomerDetail.Title', legacyLabel: t('CustomerMyBusinessByCustomerDetail.Title'),
                page: 'CustomerMyBusinessByCustomerDetail',
                props: { customerId: entityId, type: 'edit' },
                mask: 'cust026',
            });
            return true;
        }
        const otkPage = resolveOtkPageFromNotification(page);
        if (otkPage) {
            openErrorRecordFromApi(entityId, otkPage);
            return true;
        }
        return false;
    }, [dispatch, openErrorRecordFromApi, parseNotificationPayload, runDeepLinksFromSearch, t, user]);

    function setViewedNotification(notification){
        let remaining_notifications = state.notifications.filter(notif => notif.id !== notification.id); 
        dispatch({type:'clear_notification',value:remaining_notifications});
        let formData = new FormData();
        formData.append("notification_id", notification.id);
        postRequest(`/api/viewed_notifications`, formData,true)
        .then((response) => {
            if(response.status === 201){
            }
        }).catch((reason) => {
          /*console.log(reason);
          setVisible(false);
          alert(t('Common.Toast.ActionFailedDetail'));*/
        });
    }

    function setViewedNotifications(){
        dispatch({type:'clear_notification',value:[]});
        let formData = new FormData();
        state.notifications.map((notif) => formData.append("notifications[]", notif.id));
        postRequest(`/api/viewed_notifications/multiple`, formData,true)
        .then((response) => {
            if(response.status === 201){
            }
        }).catch((reason) => {
          /*console.log(reason);
          setVisible(false);
          alert(t('Common.Toast.ActionFailedDetail'));*/
        });
    }

    const openChosenNotificationPreferences = useCallback((pageType, options = {}) => {
        const pt = String(pageType ?? '').trim();
        if (!pt) return;
        chosenNotifPageTypeRef.current = pt;
        const isPriority = options.mode === 'priorityDepartments';
        chosenNotifModeRef.current = isPriority ? 'priorityDepartments' : 'channels';
        setChosenNotifDialogMode(isPriority ? 'priorityDepartments' : 'channels');
        if (isPriority) {
            primeNotificationDialogPageType(pt);
            const lookupTypes = getNotificationLookupTypes(pt);
            const db = (state.chosen_notifications || []).find((item) => lookupTypes.includes(item.type));
            const { departments, channels } = parsePriorityListChosenData(db?.data);
            setChosenNotifDepartmentIds(departments);
            setChosenNotifPriorityChannelKeys(channels);
            setChosenNotifPriorityDepartments(Array.isArray(options.departments) ? options.departments : []);
            setChosenNotifChannels([]);
            setChosenNotifDialogVisible(true);
        } else {
            setChosenNotifPriorityDepartments([]);
            setChosenNotifDepartmentIds([]);
            setChosenNotifPriorityChannelKeys([]);
            openChosenNotifications(state, pt, setChosenNotifChannels, setChosenNotifDialogVisible);
        }
    }, [state.chosen_notifications]);

    const saveChosenNotificationPreferences = useCallback(() => {
        const pt = chosenNotifPageTypeRef.current;
        if (!pt) return;
        if (chosenNotifModeRef.current === 'priorityDepartments') {
            savePriorityListChosenNotifications({
                type: pt,
                departments: chosenNotifDepartmentIds,
                channels: chosenNotifPriorityChannelKeys,
                postRequest,
                dispatch,
                toast,
                closeDialog: () => setChosenNotifDialogVisible(false),
            });
        } else {
            saveChosenNotificationsApi({
                type: pt,
                chosenNotifications: chosenNotifChannels,
                postRequest,
                dispatch,
                toast,
                closeDialog: () => setChosenNotifDialogVisible(false),
            });
        }
    }, [chosenNotifDepartmentIds, chosenNotifPriorityChannelKeys, chosenNotifChannels, dispatch, toast]);

  return (<>
    <UtilContext.Provider value={{visible,setDialogText,setVisible,openFavoriteDialog,toast,setVisibleNotifications,setFastView,setUserMaskFilter,setStandardMaskFilter,deleteStandardMaskFilter,getUserColor,getUserInitials,getSlovakColorName,formatID,hasAll,openFilePreview,getDateFormat,formatDate,openChosenNotificationPreferences}}>
    <Toast ref={toast} position={toastPosition}/>
      {children}
        <ConfirmDialog/>
        
        <Dialog visible={visible} style={{ width: '25vw',height:'25vh',backgroundColor: 'transparent',boxShadow: 'none'}} className='mypanel flex flex-row'  closable={false} draggable={false} showHeader={false}>
            <InfinitySpin 
            width='208'
            color="#000"
            />
            <p className='text-2xl font-bold text-center w-52 text-black'>{dialogText}...</p>
        </Dialog>
        <Dialog header={t("Util.FavoriteDialog.Title")} visible={favoriteVisible} style={{ width: '40vw' }} onHide={() =>  setFavoriteVisible(false)}>
        <div className="flex flex-columns">
          <div className="flex-row">
          <select 
          value={favoriteGroupValue} onChange={e => setFavoriteGroupValue(e.target.value)}
          className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
            <option  value="">{t("Util.Favorite.SelectPlaceholder")}</option> 
            {state.favorites?.map((item) => (
              <option key={item.id} value={item.id}>{item.name}</option>
            ))}  
            <option  value="nova">{t("Util.Favorite.CreateNew")}</option>               
          </select>
          {favoriteGroupValue==="nova" && <input
                    value={favoriteValue} onChange={e => setFavoriteValue(e.target.value)}
                    type="text"
                    placeholder={t("Util.Favorite.GroupNamePlaceholder")}
                    className="block w-full px-4 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                />}
                </div>
          <button onClick={() => confirmFavoriteDialog()} className='w-22 h-10 ml-8 mt-2 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t("Common.Save")}</button>
        </div>
      </Dialog>
      {/* Central file / PDF preview dialog */}
      <Dialog
        header={t("Util.FilePreview.Title")}
        visible={filePreviewVisible}
        onHide={closeFilePreview}
        style={{ width: '80vw', height: '90vh' }}
        contentStyle={{ overflow: 'hidden', display: 'flex', flexDirection: 'column', padding: 0 }}
        footer={filePreviewUrl && (
          <a
            href={filePreviewUrl}
            download={filePreviewFilename}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex justify-center items-center w-full py-2 px-4 bg-zinc-900 text-white rounded-md hover:bg-zinc-700"
          >
            {t("Util.FilePreview.Download")}
          </a>
        )}
      >
        {filePreviewVisible && filePreviewUrl && (
          <FilePreviewContent url={filePreviewUrl} filename={filePreviewFilename} t={t} />
        )}
      </Dialog>
      <ChosenNotificationsDialog
        visible={chosenNotifDialogVisible}
        mode={chosenNotifDialogMode}
        departments={chosenNotifPriorityDepartments}
        departmentIds={chosenNotifDepartmentIds}
        setDepartmentIds={setChosenNotifDepartmentIds}
        channelKeys={chosenNotifPriorityChannelKeys}
        setChannelKeys={setChosenNotifPriorityChannelKeys}
        chosenNotifications={chosenNotifChannels}
        setChosenNotifications={setChosenNotifChannels}
        onHide={() => setChosenNotifDialogVisible(false)}
        onSave={saveChosenNotificationPreferences}
      />
      <Sidebar visible={visibleNotifications} position="right" onHide={() => setVisibleNotifications(false)}>
        <div className="flex flex-row">
            <h2 className="font-semibold text-2xl pb-2 mr-4">{t("Util.Notifications.Title")}</h2>
            <button onClick={() => setViewedNotifications()} className="w-40 h-8 bg-red-600 rounded-md border-red-600 font-semibold text-white hover:bg-red-500 focus:outline-none focus:bg-red-500 disabled:opacity-25" disabled={state.notifications.length === 0 ? true : false}><div className="flex justify-center items-center"><DeleteIcon className="mr-2"/>{t("Util.Notifications.Clear")}</div></button>
        </div>
        <div className="card flex flex-col justify-content-start">
            {state.notifications.map((notification,key) => {
                const payload = parseNotificationPayload(notification);
                const moduleName = resolveNotificationModule(notification);
                const renderedMessage = resolveNotificationMessage(notification);
                return <Message severity="info" style={{
                    border: 'solid #696cff',
                    borderWidth: '0 0 0 6px',
                    color: '#696cff'
                }}
                className="border-primary w-full justify-content-start mb-2"
                content={
                    <div className="flex flex-col align-items-start">
                    <div className="flex flex-row">
                        <span className="font-semibold ml-2">{String(moduleName).toUpperCase()}</span>
                        <span className="flex justify-end w-full font-semibold ml-2"><button onClick={() => setViewedNotification(notification)} type="button"><CloseMess/></button></span>
                    </div>
                        <button
                            type="button"
                            className="ml-2 text-left hover:underline disabled:no-underline"
                            disabled={!payload?.page || (payload?.id == null && payload?.priority_id == null)}
                            onClick={() => {
                                if (openNotificationTarget(notification)) {
                                    setViewedNotification(notification);
                                    setVisibleNotifications(false);
                                }
                            }}
                        >
                            {renderedMessage}
                        </button>
                    </div>
                }/>;
            })}
        </div>
      </Sidebar>
    </UtilContext.Provider>
    </>
  );
};

export default UtilContext;